import React from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from '../PageView'
import Lex from '../../Shared/Lex'
import PageProvider from '../../../modules/PageProvider'

const Teams = ({ userStore }) => {
  const form = {}

  const getAccount = () => userStore.account

  const page = {
    clickUrl: (record) => 'team/' + record.id,
    formName: () => userStore.lex.team,
    recordType: () => 'teams',
    pageHeader: () => <h3><Lex term="team" plural /></h3>,
    newRecord: () => {
      return { name: '', description: '' }
    },
    records: () => {
      return userStore.getRecords('teams', (a, b) => ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))
    },
    filterRecords: () => true,
    formFields: (record) => {
      record ||= { name: '', description: '' }

      return <div>
        <Label><Lex term="name" /></Label><Input innerRef={el => form.name = el} defaultValue={record.name} />
        <br />
        <Label><Lex term="description" /></Label><Input
          innerRef={el => form.description = el}
          defaultValue={record.description}
        /> <br />
      </div>
    },
    saveRecord: (record) => {
      record.name = form.name.value
      record.description = form.description.value
      //    record.teamId = form.teamId.value
      //    record.priorityId = form.priorityId.value
      if (record.id) { userStore.updateTeam(record) } else { userStore.createTeam(record.name, record.description, getAccount()?.id) }
      return true
    },
    destroy: (record) => userStore.destroyTeam(record)
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Teams)
